import React, { PropsWithChildren, RefObject } from "react";
import { Paper, Slide } from "@mui/material";
import { CssHeight, CssWidth } from "../../types/UtilityTypes/UtilityTypes";
import collapsableWindowStyles from "./collapsableWindowStyles";

export type CollapsableWindowProps = {
  windowState: "minimized" | "maximized" | null;
  width?: CssWidth;
  height?: CssHeight;
  elementToFocusRef?: RefObject<HTMLElement | null>;
};

export default function CollapsableWindow({
  windowState,
  width = "30rem",
  height = "85vh",
  children,
  elementToFocusRef,
}: PropsWithChildren<CollapsableWindowProps>) {
  return (
    <Slide
      direction={"up"}
      in={!!windowState}
      onEntered={() => {
        elementToFocusRef?.current?.focus();
      }}
    >
      <Paper
        sx={{
          ...collapsableWindowStyles.paper,
          width: { xs: "auto", sm: windowState === "minimized" ? "20rem" : width },
          height: windowState === "minimized" ? "4rem" : height,
        }}
      >
        {children}
      </Paper>
    </Slide>
  );
}
